'use client';

import { useEffect } from 'react';
import { initHubMessageListener } from '@/lib/hub-message-listener';

/**
 * Renders nothing — purely a side-effect component that bootstraps the
 * Hub message listener when the project-page detects it is inside an iframe.
 * Drop this into the root layout so every project page automatically
 * responds to Hub agent commands.
 */
export default function HubMessageBridge() {
    useEffect(() => {
        initHubMessageListener();
    }, []);

    return null;
}
